module.exports = __webpack_public_path__ + "static/media/projectsImage6.7718ffd8.jpg";